// @ts-nocheck
import React from "react";

export default function WithdrawPageFaq() {
  return (
    <div className="faq_container">
          <h2>FAQ</h2>
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  How to Withdraw Crypto?
                </button>
              </h2>
              <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body">
                  To withdraw crypto from AGCX, go to Wallet → Withdraw, select your cryptocurrency, enter the recipient wallet address, choose the correct
                  network, and specify the amount. Review the details carefully before confirming. After you submit, the request waits for admin approval
                  (funds are locked). Processing time after approval may vary based on network congestion. KYC must be completed for withdrawals.
                </div>
              </div>
            </div>
    
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  How to Withdraw Crypto Step-by-step Guide
                </button>
              </h2>
              <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body">
                  <ul>
                    <li>
                      <strong>Go to the Withdrawal Section</strong> – Open Wallet → Withdraw on AGCX.
                    </li>
                    <li>
                      <strong>Select Your Crypto</strong> – Choose the cryptocurrency you want to withdraw.
                    </li>
                    <li>
                      <strong>Enter the Wallet Address</strong> – Make sure the address is correct and belongs to the selected blockchain network.
                    </li>
                    <li>
                      <strong>Choose the Network</strong> – Select the correct blockchain network (e.g., BEP20, ERC20, TRC20, Polygon).
                    </li>
                    <li>
                      <strong>Enter the Amount</strong> – Specify the amount you want to withdraw, ensuring it meets the minimum withdrawal limit.
                    </li>
                    <li>
                      <strong>Confirm &amp; Submit</strong> – Review all details carefully and confirm the withdrawal.
                    </li>
                    <li>
                      <strong>Wait for Admin Approval</strong> – Your request is queued for review. Funds stay locked until an admin approves (then it is sent on-chain) or rejects (funds return to your wallet). You can cancel while it is still pending approval.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
    
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Withdrawal hasn&apos;t arrived?
                </button>
              </h2>
              <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                <div className="accordion-body">
                  <ul>
                    <li>
                      <strong>Check Transaction Status</strong> – Use a blockchain explorer to track the transaction.
                    </li>
                    <li>
                      <strong>Verify the Wallet Address</strong> – Ensure the recipient address is correct.
                    </li>
                    <li>
                      <strong>Confirm Network Selection</strong> – The chosen network should match the recipient&apos;s wallet.
                    </li>
                    <li>
                      <strong>Check for Pending Approval</strong> – New withdrawals wait for admin approval before they are sent on-chain. Open the request in history to see status or cancel while it is still pending approval.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
  );
}
